module.exports = __webpack_public_path__ + "img/row.62b3790.webp";